/* global window, navigator */
import { CLEVERTAP_USER_PROPERTIES } from 'Constants/tracking';
import { getGeolocationPosition } from 'Actions/categoryBrowsing';

const getBadgeStatus = (user, badgeType) => {
    let badge;

    if (user && user.badges) {
        badge = user.badges.find(({ type }) => type === badgeType);
    }

    return badge && badge.status;
};

const getDefaultCTProperties = (sessionLongByCookie, countryName, countryIsoCode, lang, deviceFP) => {
    const defaultProperties = {
        [CLEVERTAP_USER_PROPERTIES.OLX_COUNTRY]: countryName,
        [CLEVERTAP_USER_PROPERTIES.OLX_COUNTRY_CODE]: countryIsoCode?.toLowerCase(),
        [CLEVERTAP_USER_PROPERTIES.LANG]: lang,
        [CLEVERTAP_USER_PROPERTIES.DFP]: deviceFP
    };

    if (typeof navigator !== 'undefined') {
        Object.assign(defaultProperties, {
            [CLEVERTAP_USER_PROPERTIES.DEVICE_LANG]: navigator.language
        });
    }
    if (sessionLongByCookie) {
        Object.assign(defaultProperties, {
            [CLEVERTAP_USER_PROPERTIES.SESSION_LONG]: sessionLongByCookie
        });
    }

    return defaultProperties;
};

const getCTUserIdentity = (userID, countryBrand, countryIsoCode) => {
    if (countryBrand === 'olxlatam') {
        return {
            [CLEVERTAP_USER_PROPERTIES.IDENTITY]: `${countryIsoCode?.toLowerCase()}_${userID}`,
            [CLEVERTAP_USER_PROPERTIES.COUNTRY_PREFIX]: true
        };
    }
    return {
        [CLEVERTAP_USER_PROPERTIES.IDENTITY]: userID
    };
};

const getCTPropertiesFromUserObj = user => {
    const fbLogin = getBadgeStatus(user, 'facebook');
    const gPlusLogin = getBadgeStatus(user, 'gplus');
    const appleLogin = getBadgeStatus(user, 'apple');

    const properties = {
        [CLEVERTAP_USER_PROPERTIES.OLX_USER_ID]: user.id,
        [CLEVERTAP_USER_PROPERTIES.NAME]: user.name,
        [CLEVERTAP_USER_PROPERTIES.GPLUS_LOGIN]: gPlusLogin,
        [CLEVERTAP_USER_PROPERTIES.FB_LOGIN]: fbLogin,
        [CLEVERTAP_USER_PROPERTIES.APPLE_LOGIN]: appleLogin,
        [CLEVERTAP_USER_PROPERTIES.PROFILE_PHOTO]: user.images && !!user.images.length,
        [CLEVERTAP_USER_PROPERTIES.AUTOGENERATED_NAME]: user.name_provided,
        [CLEVERTAP_USER_PROPERTIES.REG_DATE]: user.created_at,
        [CLEVERTAP_USER_PROPERTIES.IS_BUSINESS]: user.is_business,
        [CLEVERTAP_USER_PROPERTIES.IS_PHONE_VISIBLE]: user.is_phone_visible,
        [CLEVERTAP_USER_PROPERTIES.PHONE]: user.phone,
        [CLEVERTAP_USER_PROPERTIES.LAST_LOGIN_DATE]: user.last_login_at,
        [CLEVERTAP_USER_PROPERTIES.PHOTO]: (user.images && user.images[0] && user.images[0].url) || ''
    };

    if (user.contacts && user.contacts.isValidEmail && user.contacts.email) {
        Object.assign(properties, {
            [CLEVERTAP_USER_PROPERTIES.EMAIL]: user.contacts.email
        });
    }

    Object.keys(properties).forEach(key => properties[key] === undefined && delete properties[key]);

    return properties;
};

const pushProfileOnLogin = (userProperties, hideNotificationPopup = false) => {
    if (typeof window.clevertap !== 'undefined') {
        if (!hideNotificationPopup) {
            window.clevertap.notifications.push({
                titleText: 'Would you like to receive Push Notifications?',
                bodyText: 'We promise to only send you relevant content and give you updates on your transactions',
                okButtonText: 'Sign me up!',
                rejectButtonText: 'No thanks',
                okButtonColor: '#002f34',
                serviceWorkerPath: '/sw.js'
            });
        }
        window.clevertap.onUserLogin.push({
            Site: userProperties
        });
        window.localStorage.setItem('ct_identity', userProperties.olx_user_id);
    }
};

const cleverTapPush = userProperties => {
    if (typeof window.clevertap !== 'undefined') {
        window.clevertap.profile.push({
            Site: userProperties
        });
    }
};

const pushProfile = user => {
    const userProperties = getCTPropertiesFromUserObj(user);

    cleverTapPush(userProperties);
};

const pushLocationData = () => {
    getGeolocationPosition().then(response => {
        cleverTapPush({
            [CLEVERTAP_USER_PROPERTIES.LAT]: response.latitude,
            [CLEVERTAP_USER_PROPERTIES.LONG]: response.longitude
        });
    }).catch(() => {});
};

const handleUserObject = res => {
    if (res.data && res.data.data) {
        pushProfile(res.data.data);
    }
};

const syncLocationDataInClevertap = location => {
    const { addressComponents } = location;

    if (addressComponents) {
        const stateObj = addressComponents.find(({ type }) => type === 'STATE');
        const cityObj = addressComponents.find(({ type }) => type === 'CITY');
        const localityObj = addressComponents.find(({ type }) => type === 'NEIGHBOURHOOD');

        const properties = {
            [CLEVERTAP_USER_PROPERTIES.STATE]: stateObj && stateObj.name || '',
            [CLEVERTAP_USER_PROPERTIES.STATE_ID]: stateObj && stateObj.id || '',
            [CLEVERTAP_USER_PROPERTIES.CITY]: cityObj && cityObj.name || '',
            [CLEVERTAP_USER_PROPERTIES.CITY_ID]: cityObj && cityObj.id || '',
            [CLEVERTAP_USER_PROPERTIES.LOCALITY]: localityObj && localityObj.name || '',
            [CLEVERTAP_USER_PROPERTIES.LOCALITY_ID]: localityObj && localityObj.id || ''
        };

        cleverTapPush(properties);
    }
};

export {
    getBadgeStatus,
    getCTPropertiesFromUserObj,
    getDefaultCTProperties,
    getCTUserIdentity,
    pushProfileOnLogin,
    handleUserObject,
    pushProfile,
    pushLocationData,
    cleverTapPush,
    syncLocationDataInClevertap
};
